import reducer from './systemMessage.ducks';

export { reducer };



// WEBPACK FOOTER //
// ./src/routes/SystemMessage/index.ts